export default __webpack_public_path__ + "static/media/groupavatar.3cec5111.svg";